const common = {
    /* 星期 */
    week: {
        MONDAY: 1,
        TUESDAY: 2,
        WEDNESDAY: 3,
        THURSDAY: 4,
        FRIDAY: 5,
        SATURDAY: 6,
        SUNDAY: 0
    },
    /* 报警时间方式 */
    timeMode: {
        ALL_TIME: '0',
        DATE_MODE: '1',
        WEEK_MODE: '2'
    },
    subscribeGroupType: {
        ALARM_TYPE: 1
    },
    orgType: {
        ORG_AREA: 1,
        ORG_STRUCTURE: 2
    },
    devType: {
        //中间件服务器类型
        DEVICE_MIDDLEWARE_TYPE: 3,
        //相机类型
        DEVICE_CAMERA_TYPE: 5,
        //编码设备
        DEVICE_CODING_TYPE: 4
    },
    // 报警源
    alarmSource: {
        device: 0,
        business: 1
    },
    alarmSourceList: [
        {
            value: 0,
            label: window.vue.$t('common.ALARM_SOUECE_DEVICE')
        },
        {
            value: 1,
            label: window.vue.$t('common.ALARM_SOUECE_GENERAL')
        }
    ],
    orgNotAllocationId: '86884ef8664e41e18effd8bb53d95482',
    orgSortFiledTag: 'ORG_SORT_FIELD',
    orgColumTag: 'org-column-config',
    deviceNameRegexTag: 'DEVICE_NAME_REGEX_',
    roleType: {
        ordinaryRole: 0, //普通角色
        orgRole: 1, //组织角色
        doorAuthGroup: 2 //门禁权限组
    },
    permissionsView: ['role:view']
};
export default common;
